import React, { useState } from 'react';
import BaseModal from './BaseModal'; // Assuming BaseModal is in components folder
import './AddLabelModal.css';

const AddLabelModal = ({
  isOpen,
  onClose,
  onAddLabel,
  existingLabelTypes
}) => {
  const [newLabel, setNewLabel] = useState('');
  const [newLabelType, setNewLabelType] = useState('');
  const [keywords, setKeywords] = useState('');
  const [explanation, setExplanation] = useState('');
  const [language, setLanguage] = useState('English');
  const [typeSuggestions, setTypeSuggestions] = useState([]);

  const handleNewLabelTypeInput = (e) => {
    const input = e.target.value;
    setNewLabelType(input);

    const trimmedInput = input.trim();
    if (trimmedInput !== '') {
      const filteredTypes = existingLabelTypes.filter((type) =>
        type.toLowerCase().startsWith(trimmedInput.toLowerCase())
      );
      setTypeSuggestions(filteredTypes);
    } else {
      setTypeSuggestions([]);
    }
  };

  const selectTypeSuggestion = (type) => {
    setNewLabelType(type);
    setTypeSuggestions([]);
  };

  const predefinedPrompt = `Create keywords in ${language} (separated by semicolons) and a brief explanation in English for the following label:
Label: ${newLabel || "[Enter Label Name]"}
Type: ${newLabelType || "[Enter Label Type]"}`;

  const copyPromptToClipboard = () => {
    navigator.clipboard.writeText(predefinedPrompt)
      .then(() => alert('Prompt copied to clipboard!'))
      .catch((err) => console.error('Failed to copy prompt: ', err));
  };

  const handleAddLabel = () => {
    onAddLabel(newLabel, newLabelType, keywords, explanation);
    setNewLabel('');
    setNewLabelType('');
    setKeywords('');
    setExplanation('');
    onClose();
  };

  return (
    <BaseModal
      show={isOpen}
      title="Add a New Label"
      onClose={onClose}
      onConfirm={handleAddLabel}
      primaryActionLabel="Add Label"
      secondaryActionLabel="Cancel"
    >
      <div className="add-label-modal-content">
        <div className="add-label-modal-panels">
          {/* Left Panel */}
          <div className="add-label-modal-left-panel">
            <label className="add-label-modal-label">
              Label Name <span className="add-label-modal-required">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter a label name (e.g., Product Category)"
              className="add-label-modal-input"
              value={newLabel}
              onChange={(e) => setNewLabel(e.target.value)}
              required
            />

            <label className="add-label-modal-label">
              Label Type <span className="add-label-modal-required">*</span>
            </label>
            <div className="add-label-modal-autocomplete-container">
              <input
                type="text"
                placeholder="Enter or select a label type (e.g., Tag)"
                className="add-label-modal-input"
                value={newLabelType}
                onChange={handleNewLabelTypeInput}
                required
              />
              {typeSuggestions.length > 0 && (
                <ul className="add-label-modal-type-suggestions">
                  {typeSuggestions.map((type, index) => (
                    <li key={index} onClick={() => selectTypeSuggestion(type)}>
                      {type}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <label className="add-label-modal-label">Keywords (optional)</label>
            <input
              type="text"
              placeholder="Enter keywords separated by semicolons"
              className="add-label-modal-input"
              value={keywords}
              onChange={(e) => setKeywords(e.target.value)}
            />

            <label className="add-label-modal-label">Explanation (optional)</label>
            <textarea
              placeholder="Provide a brief explanation for this label"
              className="add-label-modal-input"
              value={explanation}
              onChange={(e) => setExplanation(e.target.value)}
              rows="3"
            />
          </div>

          {/* Divider */}
          <div className="add-label-modal-divider"></div>

          {/* Right Panel */}
          <div className="add-label-modal-right-panel">
            <label className="add-label-modal-label">Prompt Language</label>
            <input
              type="text"
              placeholder="Enter language for the prompt (default: English)"
              className="add-label-modal-input"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            />

            <p className="add-label-modal-chatgpt-prompt-text">
              Use AI to generate keywords and explanations:
            </p>
            <textarea
              readOnly
              className="add-label-modal-chatgpt-prompt"
              value={predefinedPrompt}
              rows="5"
            />
            <button className="primary-button" onClick={copyPromptToClipboard}>
              Copy Prompt
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

export default AddLabelModal;
